import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Reps from "@/pages/Reps";
import RepDetail from "@/pages/RepDetail";
import Ledger from "@/pages/Ledger";
import Reconciliation from "@/pages/Reconciliation";
import Payouts from "@/pages/Payouts";
import Audit from "@/pages/Audit";
import ContractTemplate from "@/pages/ContractTemplate";
import Tax1099 from "@/pages/Tax1099";
import TrainingAdmin from "@/pages/TrainingAdmin";
import RepPortal from "@/pages/RepPortal";
import RepTraining from "@/pages/RepTraining";
import VotelSync from "@/pages/VotelSync";

function Loading() {
  return <div className="flex h-screen items-center justify-center text-muted-foreground font-mono text-sm">Loading…</div>;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "rep") return <Navigate to="/portal" replace />;
  return <Layout>{children}</Layout>;
}

function RepOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "rep") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/portal" element={<RepOnly><RepPortal /></RepOnly>} />
            <Route path="/portal/training" element={<RepOnly><RepTraining /></RepOnly>} />
            <Route path="/" element={<AdminOnly><Dashboard /></AdminOnly>} />
            <Route path="/reps" element={<AdminOnly><Reps /></AdminOnly>} />
            <Route path="/reps/:id" element={<AdminOnly><RepDetail /></AdminOnly>} />
            <Route path="/ledger" element={<AdminOnly><Ledger /></AdminOnly>} />
            <Route path="/reconciliation" element={<AdminOnly><Reconciliation /></AdminOnly>} />
            <Route path="/votel" element={<AdminOnly><VotelSync /></AdminOnly>} />
            <Route path="/payouts" element={<AdminOnly><Payouts /></AdminOnly>} />
            <Route path="/contract-template" element={<AdminOnly><ContractTemplate /></AdminOnly>} />
            <Route path="/tax" element={<AdminOnly><Tax1099 /></AdminOnly>} />
            <Route path="/training" element={<AdminOnly><TrainingAdmin /></AdminOnly>} />
            <Route path="/audit" element={<AdminOnly><Audit /></AdminOnly>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
